/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonAgreementFullDTO,
  PersonAgreementFullDTOOptional,
  PersonAgreementFullDTOMetaI,
  PersonAgreementFullDTOTrackedI,
} from "./person-agreement-full-dto";
import {
  PersonAgreementFullDTOTracked,
  PersonAgreementFullDTOMeta,
} from "./person-agreement-full-dto";

/**
 *
 * @export
 * @interface PersonAgreementsDTO
 */
export interface PersonAgreementsDTOOptional {
  /**
   *
   * @type {Array<PersonAgreementFullDTO>}
   * @memberof PersonAgreementsDTO
   */
  personAgreements?: PersonAgreementFullDTOOptional[];
}

export interface PersonAgreementsDTO extends PersonAgreementsDTOOptional {
  /**
   *
   * @type {Array<PersonAgreementFullDTO>}
   * @memberof PersonAgreementsDTO
   */
  personAgreements?: PersonAgreementFullDTO[];
}

export interface PersonAgreementsDTOTrackedI {
  /**
   *
   * @type {Array<PersonAgreementFullDTO>}
   * @memberof PersonAgreementsDTO
   */
  personAgreements?: PersonAgreementFullDTOTrackedI[];
  personAgreementsIsSet: boolean;
}

transformDatesMap.set(
  "PersonAgreementsDTO",
  function (model: PersonAgreementsDTO) {
    const transformDatespersonAgreements = transformDatesMap.get(
      "PersonAgreementFullDTO",
    );
    if (transformDatespersonAgreements) {
      model.personAgreements?.forEach((sub) => {
        transformDatespersonAgreements(sub);
      });
    }
  },
);

export type PersonAgreementsDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  personAgreements: PropertyMeta<PersonAgreementFullDTOMetaI>;
}>;

export var PersonAgreementsDTOMeta: PersonAgreementsDTOMetaI =
  {} as PersonAgreementsDTOMetaI;
PersonAgreementsDTOMeta = typeMeta("PersonAgreementsDTO", {
  personAgreements: propertyMeta(
    "personAgreements",
    true,
    false,
    false,
    PersonAgreementFullDTOMeta,
  ),
});

const metaI = PersonAgreementsDTOMeta;

registerMeta(() => {});

export class PersonAgreementsDTOTracked implements PersonAgreementsDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  personAgreements__I?: PersonAgreementFullDTOTracked[] = undefined;
  personAgreementsIsSet: boolean = false;
  set personAgreements(v: undefined | PersonAgreementFullDTOTracked[]) {
    if (v !== undefined) {
      this.personAgreements__I = v;
      this.personAgreementsIsSet = true;
    } else {
      this.personAgreements__I = v || undefined;
      this.personAgreementsIsSet = false;
    }
    this.changeTracker = true;
  }
  get personAgreements() {
    return this.personAgreements__I;
  }
  constructor(config?: PersonAgreementsDTOOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.personAgreements?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: PersonAgreementsDTOOptional,
    options?: AssignOptions,
  ): PersonAgreementsDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.personAgreements &&
      this.personAgreementsApplyFilter(optionsRequired.filter)
    ) {
      this.personAgreements = config.personAgreements?.map(
        (a) => new PersonAgreementFullDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.personAgreementsIsSet = false;
      else this.personAgreementsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonAgreementsDTOTrackedI {
    const cloned = {} as PersonAgreementsDTOTrackedI;
    if (
      this.personAgreementsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.personAgreementsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personAgreementsIsSet = true;
      cloned.personAgreements = this.personAgreements
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.personAgreementsIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonAgreementsDTOTrackedI {
    if (!this.personAgreementsApplyFilter(filter))
      this.personAgreementsIsSet = false;

    this.personAgreements?.forEach((a) => a.unassignAll(filter));
    return this;
  }
  personAgreementsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementsDTOMeta.personAgreements,
      PersonAgreementsDTOMeta,
      this.personAgreements,
      this,
    );
  }
  personAgreementsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personAgreementsIsSet && this.personAgreementsApplyFilter(filter))
      return true;

    return this.personAgreements?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.personAgreementsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
